import Cookies from 'js-cookie'

export const getFromCookies = (key) => {
  return Cookies.get(key)
}

export const setInCookies = (key, value, options = {}) => {
  Cookies.set(key, value, options)
}

export const removeCookie = (key) => {
  Cookies.remove(key)
}